import InternalDocumentIncomingDetail from './modules/InternalDocumentIncoming/InternalDocumentIncomingDetail'
import { InternalDocumentOutgoingDetail } from './modules/InternalDocumentOutgoing'
import WorkDetail from './modules/work/WorkDetail'
import CompanyWorkSchedulePage from './pages/CompanyWorkSchedulePage'
import DashBoardPage from './pages/DashBoardPage'
import LoginPage from './pages/LoginPage'
import MissionPage from './pages/MissionPage'
import ProfilePage from './pages/ProfilePage'
import UpdateProfile from './pages/UpdateProfile'
import WorkPage from './pages/WorkPage'
import TinTucPage from './pages/TinTucPage'
import CompanyWorkScheduleDetail from './modules/CompanyWorkSchedule/CompanyWorkScheduleDetail'
import MissionDetail from './modules/mission/MissionDetail'
import TinTucDetail from './modules/tintuc/TinTucDetail'
import InternalDocumentIncomingPage from './pages/InternalDocumentIncomingPage'
import InternalConnectedDocumentIncomingPage from './pages/InternalConnectedDocumentIncomingPage'
import InternalConnectedDocumentOutgoingPage from './pages/InternalConnectedDocumentOutgoingPage'
import InternalDocumentOutgoingPage from './pages/InternalDocumentOutgoingPage'
import ProposalPage from './pages/ProposalPage'
import ProposalDetail from './modules/Proposal/ProposalDetail'
import ListUserContactPage from './pages/ListUserContactPage'
import ListDepartmentContactPage from './pages/ListDepartmentContactPage'
import { InternalConnectedDocumentIncomingDetail } from './modules/InternalConnectedDocumentIncoming'
import {
  InternalConnectedDocumentOutgoingDetail,
  InternalConnectedDocumentOutgoingCreate,
} from './modules/InternalConnectedDocumentOutgoing'
import InternalDocumentSignPage from './pages/InternalDocumentSignPage'
import MissionCreateForm from './modules/MissionCreateDocument/MissionCreateForm'
import { InternalDocumentSignDocDetailPage } from './modules/InternalDocumentSign'
import ProposalSalaryRequestPage from './pages/ProposalSalaryRequestPage'
import ProposalSalaryDetailPage from './modules/SalaryRequest/ProposalSalaryDetailPage'
import CreateSalary from './modules/SalaryRequest/CreateSalary'
import InternalMessageReceivePage from './modules/InternalMessage/InternalMessageReceivePage'
import InternalMessageReceiveDetailPage from './modules/InternalMessage/InternalMessageReceiveDetailPage/InternalMessageReceiveDetailPage'
import InternalMessageSendPage from './modules/InternalMessage/InternalMessageSendPage/InternalMessageSendPage'
import InternalMessageSendDetailPage from './modules/InternalMessage/InternalMessageSendDetailPage/InternalMessageSendDetailPage'
import InternalMessageDetail from './modules/InternalMessage/InternalMessageReceivePage/InternalMessageDetail'
import InternalMessageSendDetail from './modules/InternalMessage/InternalMessageSendDetailPage/InternalMessageSendDetail'
export const normalRoutes = [
  {
    path: '/login',
    component: <LoginPage />,
    name: 'Login',
  },
  // {
  //     path: "/portalv2",
  //     component: PortalPageV2,
  //     name: "Trang chủ",
  // },
]

export const routes = [
  {
    path: '/',
    component: <DashBoardPage />,
    name: 'Trang chủ',
  },
  {
    path: '/internal-document/incoming-document',
    component: <InternalDocumentIncomingPage />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-document/incoming-document',
    component: <InternalDocumentIncomingPage />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-document/outgoing-document',
    component: <InternalDocumentOutgoingPage />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-document/sign-document',
    component: <InternalDocumentSignPage />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-document/incoming-document/view/:documentId',
    component: <InternalDocumentIncomingDetail />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-document/outgoing-document/view/:documentId',
    component: <InternalDocumentOutgoingDetail />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-document/sign-document/view/:documentId',
    component: <InternalDocumentSignDocDetailPage />,
    name: 'Chi tiết',
  },
  {
    path: '/work',
    component: <WorkPage />,
    name: 'Công việc',
  },
  {
    path: '/work/view/:workId',
    component: <WorkDetail />,
    name: 'Chi tiết công việc',
  },
  {
    path: '/my-profile',
    component: <ProfilePage />,
    name: 'Cá nhân',
  },
  {
    path: '/update-profile',
    component: <UpdateProfile />,
    name: 'Cập nhật',
  },
  {
    path: '/company-work-schedule',
    component: <CompanyWorkSchedulePage />,
    name: 'Cập nhật',
  },
  {
    path: '/company-work-schedule/view/:companyWorkId',
    component: <CompanyWorkScheduleDetail />,
    name: 'Cập nhật',
  },
  {
    path: '/utility/general-notifications',
    component: <TinTucPage />,
    name: 'Thông báo chung',
  },
  {
    path: '/utility/general-notifications/view/:newsId',
    component: <TinTucDetail />,
    name: 'Chi tiết thông báo chung',
  },
  {
    path: '/mission',
    component: <MissionPage />,
    name: 'Nhiệm vụ',
  },
  {
    path: '/mission/create',
    component: <MissionCreateForm />,
    name: 'Tạo mới nhiệm vụ',
  },
  {
    path: '/mission/view/:taskId',
    component: <MissionDetail />,
    name: 'Chi tiết Nhiệm vụ',
  },
  {
    path: '/proposal',
    component: <ProposalPage />,
    name: 'Hành chính',
  },
  {
    path: '/proposal/view/:proposalId',
    component: <ProposalDetail />,
    name: 'Chi tiết hành chính',
  },
  {
    path: '/utility/contacts',
    component: <ListUserContactPage />,
    name: 'Danh bạ',
  },
  {
    path: '/utility/contacts/users',
    component: <ListUserContactPage />,
    name: 'Danh bạ nhân viên',
  },
  {
    path: '/utility/contacts/departments',
    component: <ListDepartmentContactPage />,
    name: 'Danh bạ phòng ban',
  },
  {
    path: '/internal-connected-document',
    component: <InternalConnectedDocumentIncomingPage />,
    name: 'Văn bản liên thông nội bộ',
  },
  {
    path: '/internal-connected-document/incoming-document',
    component: <InternalConnectedDocumentIncomingPage />,
    name: 'VBLTNB đến',
  },
  {
    path: '/internal-connected-document/incoming-document/view/:documentId',
    component: <InternalConnectedDocumentIncomingDetail />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-connected-document/outgoing-document',
    component: <InternalConnectedDocumentOutgoingPage />,
    name: 'VBLTNB đi',
  },
  {
    path: '/internal-connected-document/outgoing-document/view/:documentId',
    component: <InternalConnectedDocumentOutgoingDetail />,
    name: 'Chi tiết',
  },
  {
    path: '/internal-connected-document/outgoing-document/create/:documentId',
    component: <InternalConnectedDocumentOutgoingCreate />,
    name: 'Chi tiết',
  },
  {
    path: '/proposal-salary-request',
    component: <ProposalSalaryRequestPage />,
    name: 'Duyệt lương',
  },
  {
    path: '/proposal-salary-request/create',
    component: <CreateSalary />,
    name: 'Tạo mới',
  },
  {
    path: '/proposal-salary-request/view/:proposalId',
    component: <ProposalSalaryDetailPage />,
    name: 'Chi tiết',
  },
  {
    path: '/utility/internal-message',
    component: <InternalMessageReceivePage />,
    name: 'Tin nhắn nội bộ',
  },
  {
    path: '/utility/internal-message/receive',
    component: <InternalMessageReceivePage />,
    name: 'Tin nhắn đến',
  },
  {
    path: '/utility/internal-message/receive/view/:code',
    component: <InternalMessageDetail />,
    name: 'Chi tiết tin nhắn nội bộ đến',
  },
  {
    path: '/utility/internal-message/send',
    component: <InternalMessageSendPage />,
    name: 'Tin nhắn đi',
  },
  {
    path: '/utility/internal-message/send/view/:code',
    component: <InternalMessageSendDetail />,
    name: 'Chi tiết tin nhắn nội bộ đi',
  },
]
